class EscrituracaoService extends AbstractService

  configure: (configs, injector) ->
    configs.url = '/'

  getList: (empresa, callback) ->
    @doRequest('GET', {}, callback, url: "/api/empresas/#{empresa}/escrituracao")

angular.module('eficienciaFiscalModule').service('escrituracaoService', EscrituracaoService)
